<template>
  <div class="bb-sidebar-notifications" @click.stop="openNotificationsBar()">
    <div class="bb-sidebar-notifications__icon">
    <i class="icon-notifications"></i>
      <span class="bb-sidebar-notifications__indicator"
            :class="{'bb-sidebar-notifications__indicator_active':haveMessage}"/>
    </div>
    <transition name="fade">
      <span v-if="sidebarOpen" class="bb-sidebar-notifications__title">Notifications</span>
    </transition>
  </div>
</template>

<script>
import { HR_NOTIFICATION_NO_RAED_STATUS_ID } from '@/constants/hrNotificationReadStatus'

export default {
  name: 'NotificationIndicator',
  props: {sidebarOpen: Boolean},
  computed: {
    haveMessage () {
      return this.notificationsList.some((el) => el.readStatus === HR_NOTIFICATION_NO_RAED_STATUS_ID)
    },
    notificationsList: {
      get () {
        return this.$store.getters.notificationsList
      },
      set (data) {
        this.$store.dispatch('setNotificationsList', data)
      }
    },
    openNotifications: {
      get () {
        return this.$store.getters.openNotifications
      },
      set (data) {
        this.$store.dispatch('setOpenNotifications', data)
      }
    }
  },
  methods: {
    openNotificationsBar () {
      this.openNotifications = !this.openNotifications
    }
  }
}
</script>

<style lang="scss" scoped>
  @import "../../sass/variables";
  @import "../../sass/transition";

  .bb-sidebar-notifications {
    display: flex;
    align-items: center;
    min-width: 81px;
    padding: 0 32px 0;
    cursor: pointer;
    user-select: none;

    &__icon {
      position: relative;

      i {
        text-align: center;
        color: $color-white;
        margin-left: -2px;
      }
    }

    &__indicator {
      position: absolute;
      width: 7px;
      height: 7px;
      top: 1px;
      left: 9px;
      background: $color-accent;
      border-radius: 50%;
      border: 1px solid $color-white;

      &_active {
        background: $color-red-orange;
      }
    }

    &__title {
      margin-left: 15px;
      font-size: 15px;
      line-height: 17px;
      color: $color-white;
      white-space: nowrap;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/Notifications/NotificationIndicator.vue